(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),

        splitText : {},

        loadAnimations: function(){
            var timeline = new TimelineMax();

            if (__.global.screen === "large") {

                __.splitText.banner_title =  __.global.splitText($( '.pg-about-banner--title' ));
                __.splitText.banner_text =  __.global.splitText($( '.pg-about-banner--content-text p' ));


                timeline
                .add(TweenMax.to('.pg-about-content', 0, {opacity: 1 }), '+=1')
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2')
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )
                .add(TweenMax.from('.pg-about-banner--image__desktop', 0.4, __.global.animations.slide.left) );

                __.global.staggerDisplay( __.splitText.banner_title, timeline);
                timeline.add(TweenMax.from('.pg-about-banner--body', 0.2, __.global.animations.slide.up));

                __.global.staggerDisplay( __.splitText.banner_text, timeline);
                timeline.call(function() {
                    __.splitText.banner_title.revert();
                    __.splitText.banner_text.revert();

                });
                timeline
                .add(TweenMax.to('.pg-about-content', 0, {opacity: 1 }), '0')

                .call(function() {
                    __.global.completeLoadInAnimation();
                })
                
                .call(function() {
                    // __.global.completeLoadInAnimation();
                    __.pageParallax();

                });
                timeline.play();
            }
            else{
                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                .add(TweenMax.from('.pg-about-banner--image__mobile', 0.4, __.global.animations.fade.right) );
                timeline.play();
            }
        },
        pageParallax : function(){

            new ScrollMagic.Scene({
                duration: '100%',
                triggerHook: 0,
            })
            .setTween( TweenMax.to('.pg-about-banner--image__desktop', 0.4, {transform: 'translateY(250px)'})  )
            .addTo(__.controller);
            
        },

        calloutAnimations: function(){
            var timeline = new TimelineMax();



            __.splitText.content_title =  __.global.splitText($( '.pg-about-content--content-title' ));
            __.splitText.content_text =  __.global.splitText($( '.pg-about-content--content-text p' ));

            timeline
                .add(TweenMax.from('.pg-about-content--image-top', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-about-content--inner', 0.4, __.global.animations.slide.up) );
                __.global.staggerDisplay( __.splitText.content_title, timeline);
                __.global.staggerDisplay( __.splitText.content_text, timeline);
                timeline.call(function(){
                    __.splitText.content_title.revert();
                    __.splitText.content_text.revert();
                });
            new ScrollMagic.Scene({
                duration: $('.pg-about-content--image-top').height(),
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-content--container'
            })
            .setTween( timeline )
            .addTo(__.controller);



            var timeline2 = new TimelineMax();
            timeline2
                .add(TweenMax.fromTo('.pg-about-content--image-left', 1, {opacity:-1, transform: 'translateY(-150px)', ease:Linear.easeNone}, {opacity: 10, transform: 'translateY(0)', ease:Linear.easeNone } ) )
                .add(TweenMax.fromTo('.pg-about-content--image-right', 0.75, {opacity:-1, transform: 'translateY(-500px)', ease:Linear.easeNone}, {opacity: 14, transform: 'translateY(0)', ease:Linear.easeNone } ), '-=0.75' );
            new ScrollMagic.Scene({
                duration: '100%',
                offset: 0,
                triggerHook: 1,
                triggerElement: '.pg-about-content--bottom'
            })
            .setTween( timeline2 )
            .addTo(__.controller);

        },

        serviceAnimations: function(){
            // Setup text object for services
            __.splitText.services = {};

            // Start timeline object
            var timeline = new TimelineMax();
            // Set text up for animation
            __.splitText.services.mainTitle  =  __.global.splitText( $( '.pg-about-services--title' ) );
            __.splitText.services.mainText  =  __.global.splitText( $( '.pg-about-services--text' ) );

            // Build animation timeline
            // timeline.add(TweenMax.from( group, 0.4, __.global.animations.slide.up) ); // Animate the box sliding up
            __.global.staggerDisplay(  __.splitText.services.mainTitle, timeline);  // Animate the main text in
            __.global.staggerDisplay(  __.splitText.services.mainText, timeline);  // Animate the main text in

            timeline.call(function(){ // Reset the text to remove extra html required for animations
                __.splitText.service.mainTitle.revert();
                __.splitText.service.mainText.revert();
            });
                
            // Build scene using timeline, set duration to the height of the box, trigger on itself
            new ScrollMagic.Scene({
                duration: 300,
                offset: 0,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-services'
            })
            .setTween( timeline )
            .addTo(__.controller);



            // Each service group will animate in separately 
            $('.pg-about-services--group').each(function(){


                var group = $(this);
                var groupID = group.attr('id');


                // Check if the current url has a hash
                if(window.location.hash) {

                    // If it does, check if it matches this group and skip the group tween if so
                    if(window.location.hash === "#" + groupID){
                        return;
                    }
                }


                // Setup text object for group
                __.splitText.services[groupID] = {};


                // Start timeline object
                var timeline = new TimelineMax();

                // Set text up for animation
                __.splitText.services[groupID].text   =  __.global.splitText( group.find( '.pg-about-services--group-title' ) );

                // Build animation timeline
                // timeline.add(TweenMax.from( group, 0.4, __.global.animations.slide.up) ); // Animate the box sliding up
                __.global.staggerDisplay(  __.splitText.services[groupID].text, timeline);  // Animate the main text in

                timeline.call(function(){ // Reset the text to remove extra html required for animations
                    __.splitText.services[groupID].text.revert();
                });

                timeline.staggerFrom( group.find('.pg-about-services--service') , 0.6, __.global.animations.slide.up, 0.3, '-=0.15' );

                
                // Build scene using timeline, set duration to the height of the box, trigger on itself
                new ScrollMagic.Scene({
                    duration: group.height(),
                    offset: 200,
                    triggerHook: 1,
                    reverse: false,
                    triggerElement: group.get(0)
                })
                .setTween( timeline )
                .addTo(__.controller);
            });

        },
        pointsAnimations: function(){
            var timeline = new TimelineMax();

            __.splitText.callout_title =  __.global.splitText($( '.pg-about-callout--head-title' ));
            __.splitText.callout_text =  __.global.splitText($( '.pg-about-callout--head-text' ));

            timeline.add(TweenMax.from('.pg-about-callout', 0.4, __.global.animations.fade.up) );
            __.global.staggerDisplay( __.splitText.callout_title, timeline);
            __.global.staggerDisplay( __.splitText.callout_title, timeline);
            timeline.call(function(){
                __.splitText.callout_title.revert();
                __.splitText.callout_text.revert();
            });

            new ScrollMagic.Scene({
                duration: '33%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-callout'
            })
            .setTween( timeline )
            .addTo(__.controller);

            var timeline2 = new TimelineMax();
            var count = 0;


            __.splitText.callouts_headers =  __.global.splitText($( '.pg-about-callout--single-header' ));
            __.splitText.callouts_titles =  __.global.splitText($( '.pg-about-callout--single-title' ));

            
            $('.pg-about-callout--single').each(function(){
                var _this = $(this);
                var timelineTemp = new TimelineMax();
                var delay = '+=' + count++ * 0.25;


                timelineTemp.add(TweenMax.from(_this.find('.pg-about-callout--icon'), 1, {opacity: 0}, 0) );
                timelineTemp.staggerFrom( $(this).find('.pg-about-callout--single-header').find('.pga-text--word') , 0.3, __.global.animations.slide.up, 0.01, '-=0.15' );
                timelineTemp.staggerFrom( $(this).find('.pg-about-callout--single-title').find('.pga-text--word') , 0.3, __.global.animations.slide.up, 0.01, '-=0.15' );

                timeline2.add(timelineTemp, delay);
            });

            timeline2.call(function(){
                __.splitText.callouts_headers.revert();
                __.splitText.callouts_titles.revert();
             });
            new ScrollMagic.Scene({
                duration: '33%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-callout--callouts'
            })
            .setTween( timeline2 )
            .addTo(__.controller);

        },
        rulesAnimations: function(){


            
            new ScrollMagic.Scene({
                duration: 300,
                offset: 0,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-rules'
            })
            .setTween( TweenMax.from('.pg-about-rules', 1, __.global.animations.fade.up ) )
            .addTo(__.controller);

            __.splitText.rules_headers =  __.global.splitText($( '.pg-about-rules--title' ));
            __.splitText.rules_titles =  __.global.splitText($( '.pg-about-rules--text p' ));


            var timeline = new TimelineMax();
           
            timeline.add(TweenMax.from('.pg-about-rules--header--highlight', 1, { width: 0  }) );

            __.global.staggerDisplay( __.splitText.rules_headers, timeline);
            __.global.staggerDisplay( __.splitText.rules_titles, timeline);

            timeline.call(function() {
                __.splitText.rules_headers.revert();
                __.splitText.rules_titles.revert();
            });
            new ScrollMagic.Scene({
                duration: $('.pg-about-rules--header').height(),
                offset: 300,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-rules'
            })
            .setTween( timeline )
            .addTo(__.controller);



            var timeline2 = new TimelineMax();
            timeline2
            .add(TweenMax.from($('.pg-about-rules--background__left'), 1, __.global.animations.slide.up, 0) );
            // .add(TweenMax.from($('.pg-about-rules--background__left'), 1,{transform : 'translateX(-50%)', left: '50%' }, 0) );
         
         
         
            var timelineTemp = new TimelineMax();



            var rule = $('.pg-about-rules--single--1');
            timelineTemp
                .add(TweenMax.from( rule , 1, __.global.animations.fade.right, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--number') , 1, __.global.animations.slide.up, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--rule') , 1, __.global.animations.slide.up, 0) );
            timeline2.add(timelineTemp);



            timelineTemp = new TimelineMax();
            rule = $('.pg-about-rules--single--2');
            timelineTemp
                .add(TweenMax.from( rule , 1, __.global.animations.fade.right, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--number') , 1, __.global.animations.slide.up, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--rule') , 1, __.global.animations.slide.up, 0) );
            timeline2.add(timelineTemp);

            timelineTemp = new TimelineMax();
            rule = $('.pg-about-rules--single--3');
            timelineTemp
                .add(TweenMax.from( rule , 1, __.global.animations.fade.right, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--number') , 1, __.global.animations.slide.up, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--rule') , 1, __.global.animations.slide.up, 0) );
            timeline2.add(timelineTemp);

            // timeline2.add(TweenMax.from($('.pg-about-rules--background__left'), 0.5, {top: '100%', width: '0', height:"0"} ) );



            timelineTemp = new TimelineMax();
            rule = $('.pg-about-rules--single--4');
            timelineTemp
                .add(TweenMax.from( rule , 1, __.global.animations.fade.right, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--number') , 1, __.global.animations.slide.up, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--rule') , 1, __.global.animations.slide.up, 0) );
            timeline2.add(timelineTemp);



            timelineTemp = new TimelineMax();
            rule = $('.pg-about-rules--single--5');
            timelineTemp
                .add(TweenMax.from( rule , 1, __.global.animations.slide.right, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--number') , 1, __.global.animations.slide.up, 0) )
                .add(TweenMax.from( rule.find('.pg-about-rules--rule') , 1, __.global.animations.slide.up, 0) );
            timeline2.add(timelineTemp);
            

            
            timeline2.add(TweenMax.from( '.pg-about-rules--bottom' , 0.2, { height: '0'} ));
            timeline2.add(TweenMax.fromTo( '.pg-about-rules--grid' , 0.2, { boxShadow: '0, 0, 0, rgba(0,0,0,0)'}, { boxShadow: '0 0 30px 6px rgba(0,0,0,.2)'} ));
           

            new ScrollMagic.Scene({
                duration: '50%',
                offset: 200,
                triggerHook: 1,
                triggerElement: '.pg-about-rules--container'
            })
            .setTween( timeline2 )
            .addTo(__.controller);
        },
        leadershipAnimation : function() {

            var timeline = new TimelineMax();
            timeline
                .staggerFrom(__.global.prepareText( $( '.pg-about-team--title' ) ), 1, __.global.animations.slide.up, 0 )
                .staggerFrom( $( '.pg-about-team--person') , 1, __.global.animations.fade.up, 0.25 );

            new ScrollMagic.Scene({
                duration: '50%',
                offset: 200,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-about-team'
            })
            .setTween( timeline )
            .addTo(__.controller);
        },
        locationsAnimation : function() {

            var timeline = new TimelineMax();
            timeline
            .add(TweenMax.from('.pg-about-locations--location__1', 1, {transform : 'translateY(50px)'} ) )
            .add(TweenMax.from('.pg-about-locations--location__2', 1, {transform : 'translateY(400px)'} ) );

            new ScrollMagic.Scene({
                duration: '50%',
                offset: 100,
                reverse: false,
                triggerHook: 1,
                triggerElement: '.pg-about-locations'
            })
            .setTween( timeline )
            .addTo(__.controller);



            

            __.splitText.location1_city =  __.global.splitText($( '.pg-about-locations--location__1').find('.pg-about-locations--city' ));
            __.splitText.location1_description_text =  __.global.splitText($( '.pg-about-locations--location__1').find('.pg-about-locations--description' ));

            __.splitText.location2_city =  __.global.splitText($( '.pg-about-locations--location__2').find('.pg-about-locations--city' ));
            __.splitText.location2_description_text =  __.global.splitText($( '.pg-about-locations--location__2').find('.pg-about-locations--description' ));

            

            var timeline2 = new TimelineMax();
            var timeline2a = new TimelineMax();
            var timeline2b = new TimelineMax();

            __.global.staggerDisplay( __.splitText.location1_city, timeline2a);
            __.global.staggerDisplay( __.splitText.location1_description_text, timeline2a);

            timeline2a
                .add(TweenMax.from($( '.pg-about-locations--location__1').find('.pg-about-locations--button' ), 1, __.global.animations.slide.up, '-=0.5' ) )
                .add(TweenMax.from($( '.pg-about-locations--location__1').find('.pg-about-locations--button--bottom' ), 1, {width: 0}, '-=0.5' ));


            __.global.staggerDisplay( __.splitText.location2_city, timeline2b);
            __.global.staggerDisplay( __.splitText.location2_description_text, timeline2b);
            timeline2b
                .add(TweenMax.from($( '.pg-about-locations--location__2').find('.pg-about-locations--button' ), 1, __.global.animations.slide.up, '-=0.5' ) )
                .add(TweenMax.from($( '.pg-about-locations--location__2').find('.pg-about-locations--button--bottom' ), 1, {width: 0}, '-=0.5' ));
            
            timeline2.add(timeline2a).add(timeline2b, 0.5);

            new ScrollMagic.Scene({
                duration: 200,
                offset: 100,
                reverse: false,
                triggerHook: 1,
                triggerElement: '.pg-about-locations--details'
            })
            .setTween( timeline2 )
            .addTo(__.controller);
        },
        // Function to call to setup functionality
        setup: function() {
            window._animations.global.setup();

            if (__.global.screen === "large") {

                __.loadAnimations();
                __.calloutAnimations();
                __.serviceAnimations();
                __.pointsAnimations();
                __.rulesAnimations();
                __.leadershipAnimation();
                __.locationsAnimation();
            }else{
                __.loadAnimations();
            }
            // __.scrollAnimations();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.aboutus = __;
})(jQuery); // Fully reference jQuery after this point.